import { IMAGE } from "../../image/image";

export const MultiChain = () => {
  return (
    <div className="section">
      <div className="container">
        <div className="multi-chain-container">
          <div className="set-desktop multi-chain-images-container">
            <div className="multi-chain-image chain-1">
              <img src={IMAGE.HOMEPAGE.CHAIN[1]} className="chain"></img>
            </div>
            <div className="multi-chain-image chain-2">
              <img src={IMAGE.HOMEPAGE.CHAIN[2]}></img>
            </div>
            <div className="multi-chain-image chain-3">
              <img src={IMAGE.HOMEPAGE.CHAIN[3]}></img>
            </div>
            <div className="multi-chain-image chain-4">
              <img src={IMAGE.HOMEPAGE.CHAIN[4]}></img>
            </div>
          </div>

          <div className="set-mobile multi-chain-images-container">
            <div className="multi-chain-image chain-1">
              <img src={IMAGE.HOMEPAGE.CHAIN[1]} className="chain"></img>
            </div>
            <div className="multi-chain-image chain-2">
              <img src={IMAGE.HOMEPAGE.CHAIN[2]}></img>
            </div>
            <div className="multi-chain-image chain-3">
              <img src={IMAGE.HOMEPAGE.CHAIN[3]}></img>
            </div>
            <div className="multi-chain-image chain-4">
              <img src={IMAGE.HOMEPAGE.CHAIN[4]}></img>
            </div>
          </div>

          <div className=" m-auto-tb">
            <div className="set-desktop out-fit-title-text-mini">
              Multi-chain asset starting <br></br> with NEAR Protocol
            </div>
            <div className="set-mobile out-fit-title-text-mini">
              Multi-chain asset starting with NEAR Protocol
            </div>
            <div className="set-desktop out-fit-detail-text mt-20">
              interoperability is needed in Crypto space. We will not stick to
              one <br></br>single chain. This means, we will diversify our
              community asset in variety <br></br>of chain and make sure its
              value is stable. This will also brings eyes not only <br></br> in
              NEAR users but many other chain such as Ethereum, Solana, Kadena,
              etc.
            </div>

            <div className="set-mobile out-fit-detail-text mt-20">
              interoperability is needed in Crypto space. We will not stick to
              one single chain. This means, we will diversify our community
              asset in variety of chain and make sure its value is stable. This
              will also brings eyes not only in NEAR users but many other chain
              such as Ethereum, Solana, Kadena, etc.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
